import React from 'react';
import { Box } from '@mui/material';
import useStyles from '../styles';

interface StepsProps {
  currentStep: number;
  totalSteps: number;
}

function Steps({ currentStep, totalSteps }: StepsProps) {
  const classes = useStyles();

  const getStepClass = (step: number) => {
    if (step === currentStep) return classes.stepActive;
    if (step < currentStep) return classes.stepCompleted;
    return classes.stepInactive;
  };

  return (
    <Box className={classes.stepsContainer}>
      {Array.from({ length: totalSteps }, (_, index) => index + 1).map((step) => (
        <Box
          key={step}
          className={`${classes.stepCircle} ${getStepClass(step)}`}
        >
          {step}
        </Box>
      ))}
    </Box>
  );
}

export default Steps;
